<div class="p-grid table-demo ">
    <div class="p-col-12">
        <p-toast key="toastmsg"></p-toast>
        <div class="card">
			<div class="header-container">
				<h3>Opponents</h3>
			</div>
			<hr>
			<section class="body-section mt-5">
				<div class="container-fluid bottom-container">
					<main>
						<div class="opponents-header-row">
							<div class="search-wrapper">
								<div class="search-container">
									<div class="row">
										<div class="col col-12 px-3 seach-bar-top"><input type="text" [(ngModel)]="playerName" placeholder="Search player"
												class="form-control search-input">
											<button (click)="searchPlayer()" class="searh-icon"><i class='bx bx-search'></i></button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="opponents-wrapper" [ngClass]="compare ? ' compared-selection ' : 'see-more'">
							<div class="row px-2 mb-19">
								<div class="col pl-0">
									<div class="float-left">
										<div class="compare-skill-btn-div"><button (click)="onClickCompare()" type="button"
												class="btn btn-success compare-skills-btn">
												compare skills</button>
		
										</div>
										<div class="compare-buttons">
											<button class="compare btn btn-success compare-skills-btn" (click)="showDialog()">
												Compare
											</button>
											<button class="cancel btn btn-border compare-skills-btn "
												(click)="OnClickCompareRemove()"> Cancel </button>
										</div>
									</div>
								</div>
								<div class="col">
									<!-- <div class="float-right"><span class="filter-by">Filter by:</span>
										<div class="dropdown-wrapper d-inline-block">
											<div class="dropdown col m-auto"><button type="button" data-toggle="dropdown"
													aria-haspopup="true" aria-expanded="false"
													class="btn pr-4 btn-secondary btn-sm btn-dropdown dropdown-toggle"><span
														class="rating-name">All</span></button>
												<div x-placement="bottom-start" class="dropdown-menu"
													style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 25px, 0px);">
													<a href="javascript:void(0)" value="0" class="dropdown-item">
														All
													</a><a href="javascript:void(0)" value="0" class="dropdown-item">
														This year
													</a><a href="javascript:void(0)" value="0" class="dropdown-item">
														Last 30 days
													</a>
												</div>
											</div>
										</div>
									</div> -->
								</div>
							</div>
							<div class="outside-modal">
								<div class="opponents-grid">
									<div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border"
										*ngFor="let opponent of compareList">
										<div class="rin-card-title"><img src={{opponent?.opponents_data[0]?.userData?.profilepic}}
												class="player-img"></div>
										<div class="rin-card-header">
											<div class="col text-center float-left">
												<div class="first-name">{{opponent?.opponents_data[0]?.userData?.fullName}}</div>
											</div>
										</div>
										<div class="rin-card-body">
											<!-- <div class="d-flex text-center justify-content-center mx-auto mt-2   mb-2 pie-chart skill"
												height="50" width="50">
												<div class="overall-spending float-left">
													<h4>skill
													</h4>
													<span>{{opponent?.opponents_data[0]?.playerRating}}</span>
												</div>
												<p-chart type="doughnut" [data]="opponent.opponents_data.TotalRating" [options]="opponent.opponents_data.options" height="92px"
													width="92px"></p-chart>
											</div> -->
											<div class="stats-wrapper float-left">
												<div class="stats-wrapper-inner"><span
														class="text-center matches">{{opponent?.opponents_data[0]?.tournamentPlayed}}
														matches</span> <span
														class="text-center winrate">{{opponent?.opponents_data[0]?.tournnamentWon}} Win
														- {{opponent?.opponents_data[0]?.ratingPercentage}}%</span>
												</div>
											</div> <!----> <!---->
										</div>
										<div class="rin-card-footer">
											<div class="mt-3"><button class="see-more" routerLink="/player-details/{{opponent.opponents_data[0]?.opponentUserId}}"
												class="btn btn-secondary Score-btn">see more</button> <span
													class="see-more  see-morecheck">
													<input type="checkbox"></span></div> <!---->
										</div>						
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-12 page-pagination-div">
							<p-paginator *ngIf="totalRecords > 0" [rows]="18" #paginator [totalRecords]="totalRecords"
								(onPageChange)="getCompareSkillList($event)" [rowsPerPageOptions]=" pagination"></p-paginator>
							<div *ngIf="totalRecords == 0">
								<span>
									Opponents Data not available.
								</span>
							</div>
						</div>
					</main>
				</div>
			</section>
			<p-dialog header="" [(visible)]="visible" [modal]="true" [breakpoints]="{ '960px': '75vw' , '768px': '100vw' }"
				[style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" class=" modal-dialog" id="Compare">
		
		
				<div class="modal-body compare-modal-body text-center">
					<div class="row compare-header-div justify-content-between"><span class="compare-title col-lg-3">Compare
							Skills </span>
						<div class="search-container col-9 col-lg-4 px-0">
							<div class="row">
								<div class="col col-12 px-3 seach-bar-top"><input type="text" placeholder="Add player"
										class="form-control search-input">
									<button class="searh-icon"><i class="bx bx-search"></i></button>
								</div>
							</div>
						</div>
					</div>
					<div class="box row px-0">
		
						<div class="widget-div">
							<div class="widget">
								<div class="name">
		
									S. Naik
								</div>
		
		
								<div class="pie-chart skill">
									<p-chart type="doughnut" [data]="data" [options]="options" height="92px" width="92px"></p-chart>
									<div class="overall-spending">
										<h4>skill
										</h4>
										<span>20.4</span>
									</div>
								</div>
							</div>
						</div>
						<div class="widget-div">
							<div class="widget">
								<div class="name">
		
									S. Naik
								</div>
		
		
								<div class="pie-chart skill">
									<p-chart type="doughnut" [data]="data" [options]="options" height="92px" width="92px"></p-chart>
									<div class="overall-spending">
										<h4>skill
										</h4>
										<span>20.4</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="box px-0">
						<div class="row rating-dropdown-div">
		
							<div class="bar-chart">
								<p-chart type="line" [data]="rankData" [options]="basicOptions" style="    height: 100%;
								width: 100%;"></p-chart>
							</div>
						</div>
		
					</div>
				</div>
		
		
		
			</p-dialog>
			<div class="modal fade" id="Compare" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-xl">
					<div class="modal-content">
						<div class="modal-header">
		
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body compare-modal-body text-center">
							<div class="row compare-header-div justify-content-between"><span class="compare-title col-lg-3">Compare
									Skills </span>
								<div class="search-container col-9 col-lg-4 px-0">
									<div class="row">
										<div class="col col-12 px-3 seach-bar-top"><input type="text" placeholder="Add player"
												class="form-control search-input">
											<button class="searh-icon"><i class="bx bx-search"></i></button>
										</div>
									</div>
								</div>
							</div>
							<div class="box row px-0">
		
								<div class="widget-div">
									<div class="widget">
										<div class="name">
		
											S. Naik
										</div>
		
		
										<div class="pie-chart skill">
											<p-chart type="doughnut" [data]="data" [options]="options" height="92px"
												width="92px"></p-chart>
											<div class="overall-spending">
												<h4>skill
												</h4>
												<span>20.4</span>
											</div>
										</div>
									</div>
								</div>
								<div class="widget-div">
									<div class="widget">
										<div class="name">
		
											S. Naik
										</div>
		
		
										<div class="pie-chart skill">
											<p-chart type="doughnut" [data]="data" [options]="options" height="92px"
												width="92px"></p-chart>
											<div class="overall-spending">
												<h4>skill
												</h4>
												<span>20.4</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="box px-0">
								<div class="row rating-dropdown-div">
		
									<div class="bar-chart">
										<p-chart type="doughnut" [data]="data" [options]="options" height="92px"
											width="92px"></p-chart>
									</div>
								</div>
		
							</div>
						</div>
		
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


